<div class="compliance-asset-list-container flex-column d-flex gap-4">
  <div class="compliance-header">
    <div>
      <a class="d-inline-block" [routerLink]="['/asset-management/compliance-overview']">
				<h2 class="d-flex align-items-center gap-2 m-0 h3">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path
							d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
							fill="#9FA1A4" />
					</svg>
          <span class="title m-0">{{ selectedRequirementName }}</span>
				</h2>
			</a>
    </div>
    <div>
			<app-compliance-filters
				[hasAssetTypesBtn]="true"
				[hasComplianceRegionBtn]="false"
				[hasComplianceStandardBtn]="false">
			</app-compliance-filters>
		</div>
  </div>

  <div class="row">
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-non-compliant-widget [requirementId]="selectedRequirementId"></app-non-compliant-widget>
		</div>
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-expiring-soon-widget [requirementId]="selectedRequirementId"></app-expiring-soon-widget>
		</div>
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-compliant-widget [requirementId]="selectedRequirementId"></app-compliant-widget>
		</div>
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-inspection-pass-rate-widget [requirementId]="selectedRequirementId"></app-inspection-pass-rate-widget>
		</div>
	</div>

	<div>
		<app-compliance-tasks
      [columns]="columns"
      [data]="complianceAssets"
      [isLoading]="isLoading"
      [isLoadingMore]="isLoadingMore"
      [hasError]="hasError"
      [isRequirementAssetList]="true"
      [isComplianceTasks]="true"
      [minWidth]="1100"
      (actionClicked)="onActionClick($event)"
      (linkClicked)="onLinkClick($event)"
      (scrolledDown)="onScrollDown()">
    </app-compliance-tasks>
	</div>
</div>